// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"334":"leaflet","962":"home"}[chunkId] + "-legacy." + {"334":"b1b17f61","962":"85935d67"}[chunkId] + ".js";
};